"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  name: 'FormulaEditorSelectFormulaModal',
  // 公式编辑-选择已有公式科目填充到当前公式中
  props: {
    // 当前正在编辑的记录
    record: {
      type: Object,
      default: () => {
        return {}; // {id,name,statType,type,formulaRules:[{key:'item',value:'#{9206911201001}',label:'#{京挑客}'}],formulaName:'#{京挑客}',formulaCode:'#{9206911201001}'}
      }
    },
    // 当前正在编辑的模板数据源
    dataSource: {
      type: Array,
      default: undefined // [record]
    }
  },
  data() {
    return {
      visible: false,
      selectedFormulaId: undefined // 当前选中的公式科目id
    };
  },
  computed: {
    // 可用于快捷填充的公式
    validFormulaList() {
      if (!this.dataSource) return [];
      const allList = this.$m.tree.findNodeAll(this.dataSource, node => (node.statType === 'formula' || node.type === 'formula') && node.id !== this.record.id);
      return allList;
    }
  },
  methods: {
    open() {
      this.selectedFormulaId = undefined;
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    handleOk() {
      if (!this.selectedFormulaId) {
        this.$message.warning('请选择公式');
        return;
      }
      const record = this.validFormulaList.find(item => item.id === this.selectedFormulaId);
      this.$emit('ok', record);
    },
    // 获取公式每一项的样式class
    getItemClass({
      key,
      value
    }) {
      let _class = '';
      switch (key) {
        case 'item':
          _class = 'm-type-primary';
          break;
        case 'base':
          _class = 'm-type-success m-m-h-4';
          break;
        case 'left':
        case 'right':
          _class = 'm-type-warning';
          break;
        default:
          _class = 'm-tips-color';
      }
      return _class;
    }
  }
};